import { color, Text } from '@starrez/starryui9';
import React from 'react';

export interface ILabelProps extends React.HtmlHTMLAttributes<HTMLLabelElement> {
    caption: string;
}

export const Label = ({ caption, ...props }: ILabelProps) => (
    <label {...props}>
        <Text color={color.Grey.G80}>{caption}</Text>
    </label>
);
